import React from "react";
import { TableCell, TableRow } from "@mui/material";
import ContactsTableRow from "./ContactsTableRow";
import EntityListTable from "../../helpers/EntityListTable";
import TableCreateButton from "../../helpers/TableCreateButton";

const ContactsTable = ({
  contacts,
  currentPage,
  onPageButtonClicked,
}) => {
  const displayedContacts = contacts.slice(0, 10);
  const hasNextPage = contacts.length === 11;

  return (
    <>
      <TableCreateButton link="create"/>
      <EntityListTable
        currentPage={currentPage}
        hasNextPage={hasNextPage}
        onPageButtonClicked={onPageButtonClicked}
        tableHeaderComponent={
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">Last Name</TableCell>
            <TableCell align="right">First Name</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        }
      >
        {displayedContacts.map(
          (contact) => <ContactsTableRow
            key={contact.contactEntityId}
            contact={contact}
          />,
        )}
      </EntityListTable>
    </>
  );
};

export default ContactsTable;
